import { Viewport } from 'next';
import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { TextGradient } from '@/shared/components/text-gradient';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { PaymentForm } from './components/payment-form';
export const viewport: Viewport = {
  initialScale: 1,
  maximumScale: 1,
  width: 'device-width'
};
export const PaymentPage = () => {
  return <>
      <PageSeo title="Оплата" description={`Оплатить занятия можно тут. ${APP_TITLE} – деловой английский для работы.`} noindex />

      <Article className="mt-[69px]">
        <TextGradient text="Оплата" tag="h1" className="mb-10 text-center text-5xl font-semibold md:text-left" />

        <PaymentForm />
      </Article>
    </>;
};
PaymentPage.Layout = MainLayout;